import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { CompanyModel } from '../models/CompanyModel';

@Injectable()
export class CompanyService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getcompany(compCode: string) {
      let params = new HttpParams();
        params = params.append("compCode", compCode);
        const options = {
            params: params
        };
        return this.http.get<CompanyModel>(this.urlsconfig.WebAPIURL_Test + 'api/Company/Getcompany',options);
    }
    public Addcompany(company: CompanyModel) {
        return this.http.post<CompanyModel>(this.urlsconfig.WebAPIURL_Test + 'api/Company/Addcompany', company);
    }


    public delcompany(compCode: string) {

      let params = new HttpParams();
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<CompanyModel>(this.urlsconfig.WebAPIURL_Test + 'api/Company/Deletecompany',options);
    }
    public getcompanyLookup(compCode: string, compName: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      params = params.append("compName", compName);
      const options = {
          params: params
      };
      return this.http.get<CompanyModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Company/CompanyLookup', options);
  }

    public getLocationLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<CompanyModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Company/CompanyLookupTop', options);
  }
}
